import { Plugin } from '@uppy/core';
import axios from 'axios';
import { CREATE_REPORT_FILES, UPLOAD_FILE } from '../graphql';
import { parseErrorMessage } from '.';

/**
 * Function that served to convert an uploaded file
 * to base64
 */

export const fileToBase64 = (file: any): Promise<string> =>
  new Promise(function(resolve: any, reject: any) {
    var reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = function() {
      resolve(reader.result);
    };
    reader.onerror = function(error: any) {
      reject(error);
    };
  });

export const onComplete = async (data: any, url: any, client: any) => {
  if (!data) {
    return { id: undefined };
  }
  const [{ name }] = data;
  const [response] = await client
    .mutate({
      mutation: CREATE_REPORT_FILES,
      variables: {
        inputs: [
          {
            reportId: undefined,
            url,
            name,
          },
        ],
      },
    })
    .then(({ data }: any) => data.createReportFiles);

  return response;
};

/**
 * uploads given file to given url
 * @param file: File
 * @param url: string
 */
export const uploadToS3 = async (file: File, url: string) => {
  const options = {
    headers: {
      'Content-Type': file.type,
    },
  };
  await axios.put(url, file, options);
};

/**
 * custom plugin to perform requests to backend
 */
export class ApolloGraphQLUploads extends Plugin {
  opts: {
    client: any;
    field: {
      name: string;
    };
    onComplete: Function;
    setFieldValue: Function;
    setUploadError: Function;
    uploadError: string;
    setFileId?: (id: string) => void;
  };

  constructor(uppy: any, opts: any) {
    super(uppy, opts);
    this.id = opts.id || 'ApolloGraphQLUploads';
    this.type = 'example';
    this.opts = Object.assign({}, {}, opts);
    this.uploadToS3AndCreateFile = this.uploadToS3AndCreateFile.bind(this); // ← this!
  }

  uploadToS3AndCreateFile(fileIDs: any) {
    return fileIDs.fileIDs.map(async (uppyFile: any) => {
      const item = this.uppy.getFile(uppyFile);
      const base64File = await fileToBase64(item.data);

      return this.opts.client
        .mutate({ mutation: UPLOAD_FILE, variables: { file: base64File } })
        .then(({ data }: any) => data.uploadFiles)
        .then(async (resp: any) => {
          let url = resp.body;
          let name = (item.meta && item.meta.name) || item.name;

          const response = await this.opts
            .onComplete([{ name }], url, this.opts.client)
            .then((data: any) => {
              this.opts.setUploadError && this.opts.setUploadError('');
              return data;
            })
            .catch((err: any) => {
              this.opts.setUploadError && this.opts.setUploadError(parseErrorMessage(err.message));
            });
          // Update formik state
          if (!this.opts.uploadError && response) {
            this.opts.setFieldValue(this.opts.field.name, response.id);
            this.opts.setFileId && response && response.id && this.opts.setFileId(response.id);
          }
        })
        .catch((err: any) => {
          this.opts.setUploadError && this.opts.setUploadError(parseErrorMessage(err.message));
        });
    });
  }

  install() {
    this.uppy.on('upload', this.uploadToS3AndCreateFile);
  }

  uninstall() {
    this.uppy.off('upload', this.uploadToS3AndCreateFile);
  }
}
